import React from 'react';
import { Path, Polyline, Svg, View, Text } from '@react-pdf/renderer';
import LogoBolsaCerealesSVG from './LogoBolsaCerealesSVG';

const Footer = () => {
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || '';
  const contactPhone = process.env.REACT_APP_CONTACT_PHONE || '';

  return (
    <View
      style={{
        position: 'absolute',
        bottom: '32px',
        right: '32px',
        textAlign: 'right',
        left: '32px',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
      fixed
    >
      <LogoBolsaCerealesSVG width="110px" height="25px" />
      {contactEmail && contactPhone && (
        <View
          style={{
            textAlign: 'right',
            flexDirection: 'row',
            justifyContent: 'space-between',
            gap: '5px',
            alignContent: 'flex-end',
          }}
        >
          <Svg
            style={{
              width: '12px',
              height: '12px',
              backgroundColor: 'transparent',
            }}
            viewBox="0 0 24 24"
            fill="white"
            stroke="#667085"
            strokeWidth="2"
          >
            <Path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></Path>
            <Polyline points="22,6 12,13 2,6"></Polyline>
          </Svg>
          <Text
            style={{
              fontSize: '10px',
              color: '#667085',
            }}
          >
            {contactEmail}
          </Text>
          <Svg
            style={{
              width: '12px',
              height: '12px',
              backgroundColor: 'transparent',
            }}
            viewBox="0 0 24 24"
            fill="white"
            stroke="#667085"
            strokeWidth="2"
          >
            <Path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></Path>
          </Svg>
          <Text style={{ fontSize: '10px', color: '#667085' }}>
            {contactPhone}
          </Text>
        </View>
      )}
    </View>
  );
};

export default Footer;
